export default __webpack_public_path__ + "static/media/separator-guides-selected.4384f87b.svg";